var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22564",
    "data-name": "Group 22564",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.048,
    height: 18,
    viewBox: "0 0 23.048 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10434",
    "data-name": "Rectangle 10434",
    width: 23.048,
    height: 18,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22564-2",
    fill: "#002D62",
    "data-name": "Group 22564",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13947",
    "data-name": "Path 13947",
    d: "M13.739,9.31a6.971,6.971,0,0,0,.346-1.662l-1.146-.555c0-.186-.005-.373-.022-.561,0-.065-.013-.129-.021-.193l1.078-.681a7,7,0,0,0-.527-1.612l-1.273.092A5.758,5.758,0,0,0,11.76,3.5l.593-1.127a7.146,7.146,0,0,0-1.264-1.131l-1.056.716a5.978,5.978,0,0,0-.674-.342L9.308.347A7.042,7.042,0,0,0,7.647,0L7.092,1.147c-.186,0-.372.006-.561.022-.065.006-.13.014-.194.022L5.657.111A7.075,7.075,0,0,0,4.044.639l.093,1.273a5.706,5.706,0,0,0-.633.414L2.376,1.734A7.065,7.065,0,0,0,1.246,3l.716,1.055a5.8,5.8,0,0,0-.343.674l-1.273.05A7,7,0,0,0,0,6.44l1.147.555c0,.186,0,.373.021.561.006.065.014.129.023.193L.111,8.43a7.067,7.067,0,0,0,.528,1.612l1.273-.092a5.915,5.915,0,0,0,.414.633l-.593,1.127A7.066,7.066,0,0,0,3,12.841l1.055-.716a5.769,5.769,0,0,0,.674.343l.05,1.273a7.006,7.006,0,0,0,1.66.346l.557-1.147c.185,0,.373-.005.561-.021.065-.005.129-.014.192-.022l.681,1.08a7.081,7.081,0,0,0,1.613-.528l-.092-1.274a6.165,6.165,0,0,0,.633-.414l1.127.593a7.127,7.127,0,0,0,1.131-1.265l-.715-1.055a6.279,6.279,0,0,0,.343-.674Zm-6.7,1.89A4.156,4.156,0,1,1,11.2,7.044,4.16,4.16,0,0,1,7.043,11.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13948",
    "data-name": "Path 13948",
    d: "M111.463,115.344a3.859,3.859,0,1,0,3.859-3.859,3.863,3.863,0,0,0-3.859,3.859m6.763-.254a2.916,2.916,0,1,1-3.158-2.651,2.915,2.915,0,0,1,3.158,2.651",
    transform: "translate(-108.279 -108.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13949",
    "data-name": "Path 13949",
    d: "M504.12,330.628a3.308,3.308,0,1,0,3.376-3.237,3.312,3.312,0,0,0-3.376,3.237m5.049-1.013a2.018,2.018,0,1,1-3.495,2.019,2.042,2.042,0,0,1,.7-2.707,2.019,2.019,0,0,1,2.8.688",
    transform: "translate(-489.72 -318.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13950",
    "data-name": "Path 13950",
    d: "M443.61,262.09a5.4,5.4,0,0,0-.012-1.16l-.9-.215a4.8,4.8,0,0,0-.2-.7l.659-.651a5.336,5.336,0,0,0-.591-1l-.888.265a4.47,4.47,0,0,0-.521-.511l.246-.892a5.4,5.4,0,0,0-1.011-.569l-.637.674a4.524,4.524,0,0,0-.7-.182l-.236-.9a5.3,5.3,0,0,0-1.158.014l-.217.9a4.44,4.44,0,0,0-.7.2l-.651-.659a5.084,5.084,0,0,0-.516.267,5.443,5.443,0,0,0-.483.322l.264.889a4.575,4.575,0,0,0-.511.52l-.892-.245a5.345,5.345,0,0,0-.569,1.009l.673.638a4.6,4.6,0,0,0-.18.7l-.9.235a5.353,5.353,0,0,0,.012,1.16l.9.214a4.653,4.653,0,0,0,.2.7l-.659.65a5,5,0,0,0,.268.515,5.351,5.351,0,0,0,.322.484l.889-.265a4.571,4.571,0,0,0,.52.51l-.244.893a5.309,5.309,0,0,0,1.009.568l.639-.673a4.348,4.348,0,0,0,.7.181l.235.9a5.437,5.437,0,0,0,1.159-.012l.214-.9a4.447,4.447,0,0,0,.7-.2l.653.659a5.172,5.172,0,0,0,.514-.267,5.227,5.227,0,0,0,.482-.323l-.264-.888a4.566,4.566,0,0,0,.511-.52l.893.245a5.281,5.281,0,0,0,.568-1.01l-.673-.639a4.506,4.506,0,0,0,.181-.7Zm-5.388,2.926a3.451,3.451,0,1,1,3.523-3.378,3.454,3.454,0,0,1-3.523,3.378",
    transform: "translate(-420.588 -248.907)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13951",
    "data-name": "Path 13951",
    d: "M101.066,105.253a4.156,4.156,0,1,0,4.156-4.156,4.161,4.161,0,0,0-4.156,4.156m8.015,0a3.859,3.859,0,1,1-3.859-3.859,3.863,3.863,0,0,1,3.859,3.859",
    transform: "translate(-98.179 -98.209)",
    fill: "#00aec7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13952",
    "data-name": "Path 13952",
    d: "M499.118,325.756a3.451,3.451,0,1,0,3.522-3.378,3.454,3.454,0,0,0-3.522,3.378m6.757.142a3.308,3.308,0,1,1-3.238-3.376,3.311,3.311,0,0,1,3.238,3.376",
    transform: "translate(-484.86 -313.17)",
    fill: "#00aec7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.3366e70dc7b342076a8b6965d1c6e747.svg";
export { ForwardRef as ReactComponent };